import i18n from '../i18n/i18n';

export const FILTER_TEAM = [
  {
    id: 1,
    name: i18n.t('contacts.common.text.titleKnoxPortal', { ns: 'contacts' }),
  },
  {
    id: 2,
    name: i18n.t('contacts.common.text.titleTeam', { ns: 'contacts' }),
  },
];

export const FILTER_TYPE = [
  {
    id: 1,
    name: i18n.t('contacts.common.text.myContacts', { ns: 'contacts' }),
  },
  {
    id: 2,
    name: i18n.t('contacts.common.text.publicContacts', { ns: 'contacts' }),
  },
];

export const FILTER_GROUP = [
  {
    id: 1,
    name: i18n.t('contacts.common.text.groupContacts', { ns: 'contacts' }),
  },
  {
    id: 2,
    name: i18n.t('contacts.common.text.eachContacts', { ns: 'contacts' }),
  },
];

export const FILTER_APPOINTER = [
  {
    id: 1,
    title: 'Appointer',
    name: i18n.t('contacts.common.button.selectedPerson', { ns: 'contacts' }),
    pubType: 'PERSONAL',
  },
  {
    id: 2,
    title: 'Team',
    name: i18n.t('contacts.common.text.dept', { ns: 'contacts' }),
    pubType: 'DEPARTMENT',
  },
  {
    id: 3,
    title: 'Division',
    name: i18n.t('contacts.common.text.division', { ns: 'contacts' }),
    pubType: 'SUBORG',
  },
  {
    id: 4,
    title: 'Company',
    name: i18n.t('contacts.common.text.comp', { ns: 'contacts' }),
    pubType: 'COMPANY',
  },
];

export const DEFAULT_PAGESIZE = [20, 30, 50];

export const TYPE_SEARCH = [
  {
    name: i18n.t('contacts.common.text.fullName', { ns: 'contacts' }),
    type: 'NAME',
  },
  {
    name: i18n.t('contacts.common.text.titleDeptComp', { ns: 'contacts' }),
    type: 'TITLENAME',
  },
  {
    name: i18n.t('contacts.common.text.dept', { ns: 'contacts' }),
    type: 'DEPTNAME',
  },
  {
    name: i18n.t('contacts.common.text.comp', { ns: 'contacts' }),
    type: 'COMPNAME',
  },
  {
    name: i18n.t('contacts.common.text.jobName', { ns: 'contacts' }),
    type: 'CHARGEBIZ',
  },
  {
    name: i18n.t('contacts.common.text.email', { ns: 'contacts' }),
    type: 'EMAIL',
  },
  {
    name: i18n.t('contacts.common.text.tel', { ns: 'contacts' }),
    type: 'TEL',
  },
  {
    name: i18n.t('contacts.common.text.note', { ns: 'contacts' }),
    type: 'NOTE',
  },
  {
    name: i18n.t('contacts.common.text.groupName', { ns: 'contacts' }),
    type: 'GROUPNAME',
  },
];

export const TYPE_SEARCH_PUBLIC_GROUP = [
  {
    name: i18n.t('contacts.common.text.groupName', { ns: 'contacts' }),
    type: 'GROUPNAME',
  },
  {
    name: i18n.t('contacts.common.text.groupMember', { ns: 'contacts' }),
    type: 'MEMBER',
  },
];

export const TYPE_SEARCH_PUBLIC_PERSONAL = [
  {
    name: i18n.t('contacts.common.text.fullName', { ns: 'contacts' }),
    type: 'NAME',
  },
  {
    name: i18n.t('contacts.common.text.titleDeptComp', { ns: 'contacts' }),
    type: 'TITLENAME',
  },
  {
    name: i18n.t('contacts.common.text.dept', { ns: 'contacts' }),
    type: 'DEPTNAME',
  },
  {
    name: i18n.t('contacts.common.text.comp', { ns: 'contacts' }),
    type: 'COMPNAME',
  },
  {
    name: i18n.t('contacts.common.text.jobName', { ns: 'contacts' }),
    type: 'CHARGEBIZ',
  },
  {
    name: i18n.t('contacts.common.text.email', { ns: 'contacts' }),
    type: 'EMAIL',
  },
  {
    name: i18n.t('contacts.common.text.tel', { ns: 'contacts' }),
    type: 'TEL',
  },
  {
    name: i18n.t('contacts.common.text.note', { ns: 'contacts' }),
    type: 'NOTE',
  },
];

export const MAX_SEARCH = 100;
